module.exports = __webpack_public_path__ + "static/media/1.e2ed7e1e.jpg";